/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".chip[_ngcontent-%COMP%]{display:inline-block;padding:5px 20px;border-radius:10rem;font-size:13px;text-transform:uppercase;width:125px;text-align:center}.chip-success[_ngcontent-%COMP%]{color:#62ca64;border:1px solid #62ca64}.chip-warning[_ngcontent-%COMP%]{color:#f80;border:1px solid #f80}.chip-error[_ngcontent-%COMP%]{color:#eb0929;border:1px solid #eb0929}.chip-info[_ngcontent-%COMP%]{color:#91d5ff;border:1px solid #91d5ff}.chip-gray[_ngcontent-%COMP%]{color:#91a3b1;border:1px solid #91a3b1}"];
export { styles as styles };
